import { apiSlice } from './apiSlice';

const USERS_URL = '/users';

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/auth`,
        method: 'POST',
        body: data
      })
    }),
    logout: builder.mutation({
      query: () => ({
        url: `${USERS_URL}/logout`,
        method: 'POST'
      })
    }),
    register: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/register`,
        method: 'POST',
        body: data
      })
    }),
    updateUser: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/profile`,
        method: 'PUT',
        body: data
      })
    }),
    getUsers: builder.query({
      query: () => ({
        url: USERS_URL,
        method: 'GET'
      }),
      providesTags: ['User']
    }),
    deleteUser: builder.mutation({
      query: (id) => ({
        url: `${USERS_URL}/${id}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['User']
    }),
    getUserAssignedItems: builder.query({
      query: (userId) => ({
        url: `${USERS_URL}/${userId}/assigned-items`,
        method: 'GET',
      }),
      providesTags: ['UserAssignedItems'],
    }),
    assignItemToUser: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/assign-item`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['UserAssignedItems', 'User'],
    }),
    assignItemToUsersBulk: builder.mutation({
      query: (data) => ({
        url: `${USERS_URL}/assign-item-bulk`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['UserAssignedItems', 'User'],
    }),
    getStockHistory: builder.query({
      query: ({ userId, itemId }) => ({
        url: `${USERS_URL}/${userId}/stock-history/${itemId}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0,
    }),
    updateUserAssignedItem: builder.mutation({
      query: ({ userId, assignedItemId, data }) => ({
        url: `${USERS_URL}/${userId}/assigned-items/${assignedItemId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['UserAssignedItems', 'User'],
    }),
    deleteUserAssignedItem: builder.mutation({
      query: ({ userId, assignedItemId }) => ({
        url: `${USERS_URL}/${userId}/assigned-items/${assignedItemId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['UserAssignedItems', 'User'],
    }),
  }),
});

export const { 
  useLoginMutation, 
  useLogoutMutation, 
  useRegisterMutation, 
  useUpdateUserMutation, 
  useGetUsersQuery, 
  useDeleteUserMutation, 
  useGetUserAssignedItemsQuery,
  useAssignItemToUserMutation,
  useAssignItemToUsersBulkMutation,
  useGetStockHistoryQuery,
  useUpdateUserAssignedItemMutation,
  useDeleteUserAssignedItemMutation,
} = userApiSlice;
